import React, { useEffect ,useState} from 'react';
import HeroSection from '../../components/HomeSections/HeroSection/HeroSection';
import AboutSection from '../../components/HomeSections/AboutSection/AboutSection';
import { useSelector, useDispatch } from 'react-redux';
import { selectSuccessMessage, hideSuccessMessage } from '../../redux/slices/successMessageSlice';
import { Box, Typography, IconButton } from '@mui/material';
import AOS from 'aos';
import 'aos/dist/aos.css';
import StatisticsSection from '../../components/HomeSections/StatisticsSection/StatisticsSection';
import ServiceSwiper from '../../components/HomeSections/serviceSection/services';
import Testimonial from '../../components/HomeSections/Testimonial/Testimonial';
import Certification from '../../components/HomeSections/Certification/Certification';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import { useLocation } from 'react-router-dom';
import { CheckCircleOutline as SuccessIcon } from '@mui/icons-material';

const Home = () => {
  const { translations,direction,language } = useLanguage();
  const t = translations;
  const { message, visible } = useSelector(selectSuccessMessage);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hideSuccessMessage());
  };
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      offset: 200,
    });

    const handleScroll = () => {
      AOS.refresh();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      AOS.refresh();
    };
  }, []);
  // Auto-hide success message after 5 seconds
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        dispatch(hideSuccessMessage());
      }, 5000); // 5 seconds

      return () => clearTimeout(timer); // Cleanup timeout on component unmount or visibility change
    }
  }, [visible, dispatch]);
  return (
    <Box sx={{ backgroundColor: "#FAFAFA" }}>
        {/* Show success message */}
        {visible && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#fff',
            color: '#12538B',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            zIndex: 1000,
            animation: 'fadeIn 1s',
            opacity: 1,
          }}
        >
          <SuccessIcon sx={{ marginRight: '10px' }} />
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 'bold',
              flex: 1,
              textAlign: 'center',
            }}
          >
            {message}
          </Typography>
          <IconButton
            sx={{
              color: '#12538B',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
            onClick={handleClose}
          >
            &#10005;
          </IconButton>
        </Box>
      )}
      {/* Hero Section */}
      <HeroSection data-aos="fade-up" t={t} direction={direction}/>
      {/* About Section */}
      <AboutSection data-aos="fade-up"  t={t} direction={direction} language={language}/>
      <StatisticsSection data-aos="fade-up"  t={t} language={language}/>
      <ServiceSwiper data-aos="zoom-in"  t={t} direction={direction} language={language}/>
      {/* <Testimonial data-aos="zoom-in"  t={t} direction={direction} language={language}/> */}
      <Certification data-aos="fade-up"  t={t}/>
    </Box>
  );
};

export default Home;
